import React from 'react';
import classNames from 'classnames';

interface ScreenReaderTextProps {
  showList: boolean;
  filteredOptionsLength: number;
  assistiveHintID: string;
  assistiveText: string;
  className?: string;
}

const ScreenReaderText = ({
  showList,
  filteredOptionsLength,
  assistiveHintID,
  assistiveText,
  className,
}: ScreenReaderTextProps): JSX.Element => {
  let statusMessage;
  if (showList && filteredOptionsLength > 0) {
    statusMessage = `${filteredOptionsLength} matching criteria available to search.`;
  } else {
    statusMessage = null;
  }
  return (
    <>
      <div className={classNames(className, 'usa-sr-only')} role="status">
        {statusMessage}
      </div>
      <span id={assistiveHintID} className="usa-sr-only">
        {assistiveText}
      </span>
    </>
  );
};

export default ScreenReaderText;
